export default __webpack_public_path__ + "static/media/brightness-incorrect2.4f261346.PNG";